import { jsx as _jsx } from "react/jsx-runtime";
import List from "components/Lists/List";
import DELETE_NEWSLETTER from "mutations/newsletters/deleteNewsletter";
import GET_NEWSLETTERS from "queries/newsletters/getNewsletters";
const NewslettersList = () => (_jsx(List, { deleteMutation: DELETE_NEWSLETTER, itemNamePlural: "newsletters", label: "Newsletters", listQuery: GET_NEWSLETTERS, listQueryDataName: "getNewsletters" }));
export default NewslettersList;
